// @flow
import { useEffect, useState } from 'react';

const useIntersectionObserver = (ref, rootMargin, threshold = 0) => {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    if (!ref.current) {
      setIsIntersecting(true);
      return () => {};
    }

    if (typeof IntersectionObserver === 'undefined') {
      // TODO: Add viewport detection for older browsers
      setIsIntersecting(true);

      return () => {};
    }

    const options = {
      root: null,
      rootMargin,
      threshold
    };

    const callback = (entries) => {
      entries.forEach((entry) => {
        setIsIntersecting(entry.isIntersecting);
      });
    };

    const observer = new IntersectionObserver(callback, options);

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };

  }, [ref, rootMargin, threshold, setIsIntersecting]);

  return isIntersecting;
};

export default useIntersectionObserver;
